<template>
  <div class="allprjPrivi">
    <div class="heard">
      <span class="title">包含人员</span>
      <el-button type="text" size="small" icon="el-icon-plus" @click="addRolePersonHandler">
        添加人员
      </el-button>
    </div>
    <div class="content-people">
      <div v-for="row in personList" :key="row.id" class="people-content">
        <img v-if="row.defaultFlag" :src="default_png" alt="图片" />
        <img v-else :src="reject_png" alt="图片" @click="delRolePersonHandler(row)" />
        {{ row.name }}({{ row.username }})
      </div>
    </div>
  </div>
</template>
<script>
import priviService from "@/CommonDP/service/privi-service";
import { mapState } from "vuex";
import { disablePrompt } from "@/CommonDP/utils/routeAuth";
import FrameWork from "@/CommonDP/components/FrameWork/index";
import asyncCom from "@/CommonDP/commons/asyncCom";
export default {
  data() {
    return {
      personList: [], // 人员
      default_png: require("@/CommonDP/assets/approval/default.png"),
      reject_png: require("@/CommonDP/assets/approval/reject.png")
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  async created() {
    await this.getPersonList();
  },
  methods: {
    // 添加人
    addRolePersonHandler() {
      const a = disablePrompt();
      if (a) {
        const { getPersonList } = this;
        const data = { min: 1 };
        asyncCom(FrameWork, data)
          .then(data => data.map(user => user))
          .then(user => {
            const userIdList = user.map(item => {
              return item.userId;
            });
            var params = {
              enterpriseId: this.enterpriseId,
              userIdList: userIdList
            };
            console.log(params, "userIdList");
            return priviService.prjManagerAdd(params);
          })
          .then(() => {
            this.$message.success({ message: "添加人员成功" });
          })
          .then(() => getPersonList());
      }
    },
    // 获取人员列表
    getPersonList() {
      const { enterpriseId } = this;
      const managerType = 0; // managerType 0:所有 1:本分院
      return priviService.prjManagerList(enterpriseId, managerType).then(({ data }) => {
        this.personList = data;
      });
    },
    // 删除角人员
    delRolePersonHandler(row) {
      const a = disablePrompt();
      const { enterpriseId } = this;
      if (a) {
        const { $confirm, $message, getPersonList } = this;
        const { id, username, name } = row;
        $confirm(`确定删除人员 ${name}${username}?`, "警告", {
          type: "warning"
        })
          .then(() => priviService.prjManagerDelete(enterpriseId, id))
          .then(() => {
            getPersonList();
            $message({ type: "success", message: "删除人员成功" });
          });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.allprjPrivi {
  width: 100%;
  height: 100%;
  overflow-x: auto;
  .heard {
    margin: 22px 0px 38px 24px;
    .title {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      margin-right: 26px;
    }
  }
  .content-people {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    overflow: auto;
    margin: 0px 30px;
    .people-content {
      display: flex;
      margin-right: 20px;
      align-items: center;
      width: 230px;
      padding-bottom: 20px;
      font-size: 14px;
    }
  }
}
</style>
